import { render } from "./FontSpecimenBlock.vue?vue&type=template&id=402c2a56"
import script from "./FontSpecimenBlock.vue?vue&type=script&lang=js"
export * from "./FontSpecimenBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/apps/FontSpecimenBlock.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "402c2a56"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('402c2a56', __exports__)) {
    api.reload('402c2a56', __exports__)
  }
  
  module.hot.accept("./FontSpecimenBlock.vue?vue&type=template&id=402c2a56", () => {
    api.rerender('402c2a56', render)
  })

}


export default __exports__